import { WidgetComponent, widgetTemplate } from './Widget';
import styles from './Widget.styles.scss';
export const widgetDefinition = {
    baseName: 'widget',
    template: widgetTemplate,
    styles,
};
export const chameleonWidget = WidgetComponent.compose(widgetDefinition);
